import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http'
import { Observable } from 'rxjs/internal/Observable'
import { of } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class HttpErrorHandlerService {
  handleError(error: HttpErrorResponse): Observable<null> {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred.');
    }
    if (error.status !== 404) {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(`Backend returned code ${error.status}`);
    }
    // Return an observable with a user-facing error message.
    return of(null)
  }

  handleErrorForSingleRecord(error: HttpErrorResponse): Observable<{}> {
    if (error.status === 0) {
      console.error('An error occurred.');
    }
    if (error.status !== 404) {
      console.error(`Backend returned code ${error.status}`);
    }

    return of({})
  }

  handleErrorForRecords(error: HttpErrorResponse): Observable<[]> {
    if (error.status === 0) {
      console.error('An error occurred.');
    }
    if (error.status !== 404) {
      console.error(`Backend returned code ${error.status}`);
    }

    return of([])
  }
}
